import { Palette } from '@core/config/constants';

/** Configuracion especifica del minijuego de ritmo. Aislada del resto del juego. */
export const RhythmConfig = {
  key: 'RhythmScene',
  title: 'Ritmo Pop',
  description: 'Toca las estrellas al compas antes de que desaparezcan.',
  icon: '🎵',
  color: Palette.primary,

  /** Duracion de la partida en milisegundos. */
  roundDurationMs: 30_000,
  /** Cada cuanto aparece una nueva estrella (ms). */
  spawnIntervalMs: 850,
  /** Tiempo de vida de cada estrella antes de desaparecer (ms). */
  noteLifetimeMs: 1_400,
  /** Radio de la estrella tocable. */
  noteRadius: 60,
  /** Puntos base por acierto. */
  pointsPerHit: 10,
  /** Bonus por mantener combo. */
  comboBonus: 2,
  /** Monedas otorgadas al finalizar por cada 100 puntos. */
  coinsPer100Points: 1,
} as const;

/** Parametros de cada nivel de dificultad del minijuego de ritmo. */
export interface RhythmDifficulty {
  readonly key: string;
  readonly label: string;
  readonly color: number;
  readonly spawnIntervalMs: number;
  readonly noteLifetimeMs: number;
  readonly roundDurationMs: number;
}

export const RHYTHM_DIFFICULTIES: readonly RhythmDifficulty[] = [
  { key: 'easy', label: '😊 Fácil', color: Palette.accent, spawnIntervalMs: 1000, noteLifetimeMs: 1750, roundDurationMs: 30_000 },
  { key: 'normal', label: '⭐ Normal', color: Palette.secondary, spawnIntervalMs: 850, noteLifetimeMs: 1400, roundDurationMs: 30_000 },
  { key: 'hard', label: '🔥 Difícil', color: Palette.primary, spawnIntervalMs: 640, noteLifetimeMs: 1050, roundDurationMs: 35_000 },
];
